import { LogOut } from "lucide-react";
import { clearSession } from "@/utils/clearSession";

/**
 * Always-available escape hatch that wipes all local session state and returns
 * to the login page. Rendered on dead-end screens that have no TopBar of their
 * own (the loading spinner, the login page) so a wedged session is always one
 * click from a clean state.
 */
export function ClearSessionButton({ className = "" }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={clearSession}
      className={`flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] transition-colors duration-100 ${className}`}
    >
      <LogOut size={14} />
      <span>Wyloguj</span>
    </button>
  );
}
